/* @flow */
import _ from 'lodash';
import Config from 'Config';
import invariant from 'invariant';
import jstz from 'jstimezonedetect';

import Cookies from 'lib/Cookies';
import userAgent from 'lib/currentUserAgent';
import EventTracking from 'lib/EventTracking';

const CSRF_COOKIE_KEY = 'csrf_token';

// TODO does it matter that this is the Node timezone instead of the client?
const timezone = jstz.determine().name();
const offset =
  new Date().getTimezoneOffset() *
  60 * // in seconds.
  -1; // invert offset since getTimezoneOffset returns + for the west and - for the east

export const staticHeaders = {
  // TODO(turadg) improve these headers to use Empire more
  'Remind101-Client-Type': 'Web',
  'Remind101-Client-Name': 'Dashboard',
  'Remind101-Client-Segment': userAgent.clientSegment(),
  // must be a version number (e.g. 5.3 or v1700) or 'dev'. Else API will 500.
  'Remind101-Client-Version': Config.Environment.EMPIRE_RELEASE,
  'Remind101-Timezone-Id': timezone,
  'Remind101-Timezone-Offset': offset,
};

export function getCsrfTokenFromCookies(cookies: ?Object): ?string {
  if (cookies) {
    return cookies[CSRF_COOKIE_KEY];
  } else {
    invariant(Cookies.isEnabled(), 'must have some source of cookies');
    return Cookies.get(CSRF_COOKIE_KEY);
  }
}

export function getCommonHeaders(csrfToken: ?string) {
  const optionalHeaders = {
    'X-CSRF-Token': csrfToken,
    'X-Client-Id': EventTracking.getClientId(),
    'X-Session-Id': EventTracking.getSessionId(),
  };

  const dynamicHeaders = _.omitBy(optionalHeaders, _.isNil);

  return { ...staticHeaders, ...dynamicHeaders };
}
